/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import {
	DndContext,
	PointerSensor,
	useSensor,
	useSensors,
	closestCenter,
	MouseSensor,
	TouchSensor
} from "@dnd-kit/core";
import {
	SortableContext,
	useSortable,
	arrayMove,
	verticalListSortingStrategy
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import FilterItemDndList from "./FilterItemDndList";
import MDBox from "components/Basics/MDBox";

const getItemCode = item => {
	return `${item.dictionary}-${item.path}`;
};

/**
 * Item component for the sortable list in the DnD context
 * @param {*} param0
 * @returns
 */
const SortableItem = ({ item, index, dictionary, deleteItem, linkItem, removeLink, onEdit }) => {
	const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
		id: getItemCode(item)
	});

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
		background: "#fff",
		border: "1px solid #ccc",
		borderRadius: "4px",
		cursor: "grab"
	};

	return (
		<MDBox p={1} mb={1} ref={setNodeRef} style={style} {...attributes} {...listeners}>
			<FilterItemDndList
				item={item}
				index={index}
				dictionary={dictionary}
				deleteItem={deleteItem}
				linkItem={linkItem}
				removeLink={removeLink}
				onEdit={onEdit}
			/>
		</MDBox>
	);
};

/**
 * Display prompt parts in a sortable list with drag and drop functionality
 * @param {*} param0
 * @returns
 */
const FiltersDndList = ({
	items,
	onChange,
	dictionary = {},
	deleteItem = () => {},
	linkItem = () => {},
	removeLink = () => {},
	onEdit = () => {}
}) => {
	/**
	 * Re emit the event to the parent component
	 */
	const sensors = useSensors(
		useSensor(MouseSensor, {
			onActivation: e => {
				e.event.target.click();
			}
		}),
		useSensor(TouchSensor, {
			onActivation: e => {
				e.event.target.click();
			}
		}),
		useSensor(PointerSensor, {
			onActivation: e => {
				e.event.target.click();
			}
		})
	);

	// Handle drag end event
	const handleDragEnd = event => {
		const { active, over } = event;
		if (!over || active.id === over.id) return;

		const oldIndex = items.findIndex(item => getItemCode(item) === active.id);
		const newIndex = items.findIndex(item => getItemCode(item) === over.id);

		const newList = arrayMove(items, oldIndex, newIndex);
		onChange(newList);
	};

	return (
		<MDBox
			m={1}
			style={{
				overflowY: "auto"
			}}
		>
			<DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
				<SortableContext
					items={items.map(item => getItemCode(item))}
					strategy={verticalListSortingStrategy}
				>
					{items.map((item, index) => (
						<SortableItem
							key={getItemCode(item)}
							dictionary={dictionary}
							item={item}
							index={index}
							deleteItem={deleteItem}
							linkItem={linkItem}
							removeLink={removeLink}
							onEdit={onEdit}
						/>
					))}
				</SortableContext>
			</DndContext>
		</MDBox>
	);
};

export default FiltersDndList;
